import angular from 'angular';
import EntitlerService from './entitlerService.service';

let EntitlerServiceModule = angular.module('entitlerService', []).service('entitlerService', EntitlerService);

export
default EntitlerServiceModule;


// WEBPACK FOOTER //
// ./app/common/entitlerService/entitlerService.js